export const MEDIA_GALLERY_DEBOUNCE_TIME = 200;
export const MEDIA_GALLERY_ITEM_ACTION_EVENT_NAME = 'item-action';
export const MEDIA_GALLERY_ITEM_TRACKING_EVENT_NAME = 'item-track';
